export const environment = {
    production: true,
    apiPath: 'https://roomsapi.norfolkpassport.com/',
    apiV2Path: 'https://bpv2api.787512.co.uk/',
    socketPath: 'https://npapi.787512.co.uk/',
};
